import * as React from "react";
import { Box, Radio, Typography, FormControlLabel } from "@mui/material";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import hacienda from "../imgs/hacienda_black.svg";
import fantasia from "../imgs/fantasialand_black.svg";
import squid from "../imgs/squidGameTitle_black.svg";
import babezzouar from "../imgs/babezzouar.svg";
import enssea from "../imgs/enssea.svg";
import essania from "../imgs/essania.svg";
import expoBlqck from "../imgs/expoBlack.svg";
import fermeB from "../imgs/fermeB.svg";
import useScreenWidth from "../hooks/useScreenWidth";
import { colors } from "../theme/Colors";
import merino from "../imgs/merino.svg";

export default function OverlayRadio({ onClick, val, check, title, icon, subtitle, time, children }) {
  const icons = {};
  icons["Alger"] = fantasia;
  icons["Blida"] = hacienda;
  icons["Babezzouar"] = babezzouar;
  icons["Enssea"] = enssea;
  icons["Essania"] = essania;
  icons["Sablette2"] = expoBlqck;
  icons["fermeB"] = fermeB;

  const [screenWidth, setScreenWidth] = useScreenWidth();

  return (
    <Box
      sx={{ cursor: "pointer", position: "relative", borderWidth: -1, transition: "250ms ease all" }}
      onClick={onClick}
      padding="0px 16px"
      maxWidth="400px"
      width={screenWidth}
      borderRadius="12px"
      boxShadow={check === val ? `inset 0 0 0 4px ${colors.main}, 0 0 50px rgba(222,50,98, 0.5)` : `inset 0 0 0 1px ${colors.main}`}
      display="flex"
      flexDirection="column"
      alignItems="center"
      bgcolor="white"
    >
      <Box>
        <Box gap="68px" display="flex" flexDirection="column" alignItems="center" sx={{ position: "relative", padding: "24px" }}>
          <Box>
            <img src={squid} height={70} />
          </Box>

          <Box display="flex" gap="20px" flexDirection="column">
            {val == "Zeralda" ? (
              <Box>
                <img style={{ width: "300px" }} src={fermeB} alt="event-place" />
              </Box>
            ) : (
              <img src={icons[`${icon}`]} alt="avatar-icon" height="38px" />
            )}
            <Box>
              {time && (
                <Typography fontFamily={"NeurialGrotesk-Medium"} textAlign="center" fontSize="18px" fontWeight="200" lineHeight="22.4px" color="black">
                  {String(time)}
                </Typography>
              )}
            </Box>
          </Box>

          <Box display="flex" flexDirection="column">
            <Typography marginBottom="5px" fontFamily={"NeurialGrotesk-Medium"} textAlign="center" fontSize="18px" fontWeight="200" lineHeight="22.4px" color="black">
              {String(title).toUpperCase()}
            </Typography>
            <Typography fontFamily={"NeurialGrotesk-Medium"} textAlign="center" fontSize="16px" fontWeight="200" lineHeight="22.4px" color="black">
              {String(subtitle)}
            </Typography>
          </Box>
        </Box>
        <Box sx={{ position: "absolute", top: 10, right: 10 }}>
          <FormControlLabel sx={{ height: "8px", width: "8px" }} value={val} control={<Radio checked={check === val ? true : false} sx={{ color: colors.main, height: "8px", width: "8px" }} checkedIcon={<CheckCircleRoundedIcon htmlColor={colors.main} />} />} />
        </Box>
      </Box>
      <Box width="100%" paddingTop="16px">
        {children}
      </Box>
    </Box>
  );
}
